import { render, staticRenderFns } from "./BaseDurationInMinutes.vue?vue&type=template&id=53bad3e1&scoped=true"
import script from "./BaseDurationInMinutes.vue?vue&type=script&lang=js"
export * from "./BaseDurationInMinutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bad3e1",
  null
  
)

export default component.exports